import { Loading } from "@/components/overlays/Loading";
import { getCmsPost } from "@/features/cms";
import { CmsPost } from "@/store/services/internal";
import { useEffect, useState } from "react";
const ArchetypeContent = ({
  selectedArchetypeKey,
  archetypeData,
  isArchetypeLoading,
  isArchetypeFetching
}: {
  selectedArchetypeKey: string;
  archetypeData?: CmsPost;
  isArchetypeLoading: boolean;
  isArchetypeFetching: boolean;
}) => {
  const [homeData, setHomeData] = useState<CmsPost | null>(null);
  const [isHomeLoading, setIsHomeLoading] = useState(false);
  const defaultErrorMsg = "Unfortunately, this page has not yet been written.";

  // For archetype index page
  useEffect(() => {
    if (selectedArchetypeKey === "home") {
      setIsHomeLoading(true);
      getCmsPost("glossary", "archetypesExplained").then(data => {
        setHomeData(data || null);
      }).catch(error => {
        console.error("Error fetching home data:", error);
      }).finally(() => {
        setIsHomeLoading(false);
      });
    }
  }, [selectedArchetypeKey]);
  if (selectedArchetypeKey === "home") {
    if (isHomeLoading) {
      return <Loading />;
    }
    if (!homeData) {
      return <div>{defaultErrorMsg}</div>;
    }
    return <div className="cms prose m-auto mb-12 mt-6 max-w-full leading-[1.5]" dangerouslySetInnerHTML={{
      __html: homeData.body && homeData.body !== "null" ? homeData.body : defaultErrorMsg
    }} />;
  }
  if (isArchetypeLoading || isArchetypeFetching || !archetypeData) {
    return <Loading />;
  }
  return <div className="cms prose m-auto mb-12 mt-6 max-w-full leading-[1.5]" data-sentry-component="ArchetypeContent" data-sentry-source-file="ArchetypeContent.tsx">
      <h1>{archetypeData.title}</h1>
      <div dangerouslySetInnerHTML={{
      __html: archetypeData.body && archetypeData.body !== "null" ? archetypeData.body : defaultErrorMsg
    }} />
    </div>;
};
export default ArchetypeContent;